import MUISwitch from "../Gauges/MUISwitch"
import Stack from '@mui/material/Stack';
import { useState, useEffect } from "react";
import { Card, Box, Typography } from "@mui/material";
import './Funnel.css';
import { useSelector, useDispatch } from "react-redux";

export default function Funnel(props){
    //console.log("IN FunnelCHART I AM IN");

    let funnel_data = {};
    let optionname = "option"+1;
    const tagcollectionvalue = useSelector((state) => state.mainpagedata.tagcollectionvalues)
    const sdate_edate_selected = useSelector((state) => state.mainpagedata.selecteddates)
    const dateselected = useSelector((state) => state.mainpagedata.selecteddate)
    const historicaldata = useSelector((state) => state.mainpagedata.historicaldata);
    const tagdetailsobject  = useSelector((state) => state.mainpagedata.tagdetailsobject )
    const devicedetailsobject  = useSelector((state) => state.mainpagedata.devicedetailsobject )
    // console.log("tagdetailsobject",tagdetailsobject,"devicedetailsobject",devicedetailsobject,"RECAGED 14FEB Funnel Tablewidget insi**********************tagcollectionvalue********************",tagcollectionvalue)
    //console.log("historicaldata in funnel",historicaldata,"devicedetailsobject",devicedetailsobject,tagdetailsobject)
    const [funnelSteps, setFunnelSteps] = useState([]);

    const truncate = (str, num) => {
        if (str.length <= num) {
          return str;
        }
        return str.slice(0, num) + '...';
      };

    const TruncatePart = ({ text, maxLength }) => {
        // Function to truncate text and add ellipsis
        const truncate1 = (str, num) => {
          if (str.length <= num) {
            return str;
          }
          return str.slice(0, num) + '...';
        };
      
        return (
          <span className="truncated-text" title={text}>
            {truncate(text, maxLength)}
          </span>
        );
      };
      
    useEffect(() => {
        var tagproperties = props.widgetprop.props.extended.tagprops;
        var datacollected = {};
        for (var i = 0; i < tagproperties.length; i++) {
            var tagid = tagproperties[i].tagid;
            var value = tagcollectionvalue[tagid];
            var operation = tagproperties[i].calculation.type_of_operation;
            var totalvalue = 0.0;
            var totlength = 1;
            if (value != undefined) {
                totlength = value?.length;
                for (var j = 0; j < value.length; j++) {
                    if ((value[j]?.y != null) && (value[j]?.y != undefined)) {
                        totalvalue = totalvalue + Number(value[j].y)
                    } else {
                        totlength = totlength - 1;
                    }
                }
            }
            if ((operation == "SUM") || (operation == "")) {
                // do nothing
            } else if (operation == "AVG") {
                totalvalue = totalvalue / totlength;
            }
            var currentoption = tagproperties[i].optionname
            var currentobject = {
                "optionname": currentoption,
                "value": totalvalue
            }
            datacollected[tagid] = currentobject;
        }
        var availableoptions = ["option1", "option2"];
        var dataobject = {};
        for (const property in datacollected) {
            for (var i = 0; i < availableoptions.length; i++) {
                if (datacollected[property].optionname == availableoptions[i]) {
                    if (!dataobject.hasOwnProperty(availableoptions[i])) {
                        dataobject[availableoptions[i]] = {};
                    }
                    dataobject[availableoptions[i]][property] = datacollected[property].value;
                }
            }
        }
        
        let selectedOption = props.selectedValue === "option2" ? "option2" : "option1";
        let dataArray = Object.entries(dataobject[selectedOption] || {});
        if (props.energyconsumersaver === true) {
            dataArray = dataArray.sort((a, b) => b[1] - a[1]);
        } else {
            dataArray = dataArray.sort((a, b) => a[1] - b[1]);
        }
        // Map to [{label, value}] and resolve label
        const steps = dataArray.map(([tagid, value], idx) => {
            let label = tagid;
            if (!tagid.includes("vtag")) {
                const deviceId = tagdetailsobject?.[tagid]?.DeviceID;
                const deviceName = deviceId ? devicedetailsobject?.[deviceId]?.Name : null;
                const tagAlias = tagdetailsobject?.[tagid]?.Name;
                
                if (deviceName && tagAlias) {
                    label = deviceName + " : " + tagAlias;
                } else if (deviceName) {
                    label = deviceName;
                } else if (tagAlias) {
                    label = tagAlias;
                }
                // If none available, label remains as tagid
            }
            return {
                label,
                value: Number(value).toFixed(2),
                tagid
            };
        });
        setFunnelSteps(steps);
    }, [props.widgetprop, tagcollectionvalue, props.selectedValue, props.energyconsumersaver, tagdetailsobject, devicedetailsobject]);

    // Dynamic funnel colors and widths
    const funnelColors = props.energyconsumersaver === true
        ? ["#E24A4F", "#E56367", "#EA7D81", "#EF989B", "#F2B1B3", "#F7C6C8", "#FAD9DB", "#FDECEC"]
        : ["#29A55C", "#47B273", "#66BF8B", "#85CCA2", "#A3D8B9", "#BFE5CF", "#D5F2E0", "#EBFFF1"];

    // Calculate widths for each step (largest at top, smallest at bottom)
    const maxWidth = 401;
    const minWidth = 80;
    const stepCount = funnelSteps.length;
    const widthStep = stepCount > 1 ? (maxWidth - minWidth) / (stepCount - 1) : 0;

    return (
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'start', height:"200px",overflowY: 'scroll', width: '100%' }}>
            {funnelSteps.map((step, idx) => {
                const width = Math.round(maxWidth - idx * widthStep);
                const color = funnelColors[idx % funnelColors.length];
                return (
                    <div
                        key={step.tagid}
                        style={{
                            marginTop: '10px',
                            width: `${width}px`,
                            height: '28px',
                            borderRadius: '16px',
                            backgroundColor: color,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            position: 'relative',
                            overflow: 'visible' // -- add this
                        }}
                    >
                        <span className="tooltip">
                            <Typography
                                sx={{
                                    fontSize: 12,
                                    color: '#EDEFEE',
                                    lineHeight: '31px',
                                    textAlign: 'center',
                                    maxWidth: `${width - 16}px`,
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    whiteSpace: 'nowrap',
                                    display: 'block'
                                }}
                            >
                                {step.label}:{step.value}
                                <span className="tooltiptext">{step.label}   {step.value}</span>
                            </Typography>
                        </span>
                    </div>
                );
            })}
        </div>
    );
}